import React from "react"
import { cn } from "../../lib/utils"
import { RainbowButtonProps } from "./types"

export function RainbowButton({
  children,
  className,
  ...props
}: RainbowButtonProps) {
  return (
    <div className="relative group">
      {/* Large rainbow glow effect */}
      <div className="absolute -inset-4 bg-[linear-gradient(90deg,hsl(var(--color-1)),hsl(var(--color-5)),hsl(var(--color-3)),hsl(var(--color-4)),hsl(var(--color-2)))] rounded-2xl opacity-75 blur-xl group-hover:opacity-100 animate-rainbow bg-[length:200%] transition-opacity" />
      
      <button
        className={cn(
          "relative", // Changed to relative for stacking context
          "inline-flex animate-rainbow cursor-pointer items-center justify-center",
          "rounded-xl border-0 px-6 py-3 font-medium", // Reduced padding
          "bg-black text-white dark:bg-white dark:text-black",
          // Rainbow border effect
          "before:absolute before:inset-[-2px] before:-z-10 before:rounded-xl",
          "before:bg-[linear-gradient(90deg,hsl(var(--color-1)),hsl(var(--color-5)),hsl(var(--color-3)),hsl(var(--color-4)),hsl(var(--color-2)))]",
          "before:bg-[length:200%] before:animate-rainbow",
          // Inner background
          "after:absolute after:inset-[1px] after:-z-[5] after:rounded-[10px]",
          "after:bg-black dark:after:bg-white",
          "hover:scale-105 transition-all duration-300",
          className
        )}
        {...props}
      >
        {children}
      </button>
    </div>
  )
}
